import React, { useEffect, useState } from 'react';
import { FaHistory, FaFire } from 'react-icons/fa';
import Challenge from '../../components/Challenge/Challenge';
import PageHeader from '../../components/PageHeader/PageHeader';
import { useChallengeData } from '../../utils/fetchChallengeData';
import { getStreakFromHistory } from '../../utils/streak';
import './DesafioPage.css';

const RULES = [
    { label: 'Aposta inicial', value: '10€' },
    { label: 'Objetivo', value: '1000€' },
    { label: 'Odd de referência', value: '1,50' },
    { label: 'Próxima aposta', value: '75%', hint: 'do valor ganho' },
];

function DesafioPage({ onNavigate }) {
    const { challengeHistory } = useChallengeData();
    const [streak, setStreak] = useState(0);

    useEffect(() => {
        if (challengeHistory.length > 0) {
            const currentStreak = getStreakFromHistory(challengeHistory);
            setStreak(currentStreak);
        }
    }, [challengeHistory]);

    const handleHistoricoClick = () => {
        onNavigate?.('historico');
    };

    return (
        <div className="page-bg-overlay">
            <main className="page-container desafio-page-container">
                <PageHeader
                    eyebrow="Apostas"
                    title="Desafio"
                    subtitle="De 10€ a 1000€: a cada green, 75% do valor ganho passa para a aposta seguinte."
                    actions={
                        <button className="btn historico-link" onClick={handleHistoricoClick} title="Ver histórico de apostas">
                            <FaHistory />
                            <span>Ver histórico</span>
                        </button>
                    }
                >
                    {streak > 0 && (
                        <div className="streak-badge">
                            <FaFire className="streak-icon" />
                            <span>{streak} {streak === 1 ? 'green' : 'greens'} seguidos</span>
                        </div>
                    )}
                </PageHeader>

                <dl className="desafio-rules">
                    {RULES.map(rule => (
                        <div className="desafio-rule" key={rule.label}>
                            <dt>{rule.label}</dt>
                            <dd>
                                <span className="num">{rule.value}</span>
                                {rule.hint && <span className="desafio-rule-hint">{rule.hint}</span>}
                            </dd>
                        </div>
                    ))}
                </dl>

                <h2 className="section-title desafio-section-title">Aposta atual</h2>
                <Challenge />
            </main>
        </div>
    );
}

export default DesafioPage;
